(() => {
  'use strict';

  const fieldsetSelector = '#infiniteoptions-container fieldset';
  const propertyName = 'properties[Add-On(10$)]';
  const applying = new WeakSet();

  function readGroup(fieldset) {
    if (!fieldset?.matches(fieldsetSelector) || fieldset.disabled) return null;
    const property = Array.from(fieldset.querySelectorAll('input[type="hidden"]'))
      .find(input => input.name === propertyName && !input.disabled);
    if (!property) return null;
    const inputs = Array.from(fieldset.querySelectorAll('input[type="checkbox"]'));
    const none = inputs.find(input => input.value === 'None');
    if (!none || !['Pearls', 'Diamonds', 'Butterflies'].every(value => inputs.some(input => input.value === value))) return null;
    return { fieldset, property, inputs, none, choices: inputs.filter(input => input !== none) };
  }

  function normalize(group, changed) {
    if (!group || applying.has(group.fieldset)) return;
    applying.add(group.fieldset);
    try {
      let selected = group.choices.filter(input => input.checked);
      if (changed === group.none && changed.checked) selected = [];
      else if (selected.length > 3 && changed?.checked) selected = selected.filter(input => input !== changed);
      selected = selected.slice(0, 3);
      const desired = new Set(selected.length ? selected : [group.none]);
      const updates = group.inputs.filter(input => input.checked !== desired.has(input));
      updates.forEach(input => { input.checked = desired.has(input); });
      updates.filter(input => input !== changed).forEach(input => {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } finally {
      applying.delete(group.fieldset);
    }
  }

  function sync(form) {
    document.querySelectorAll(fieldsetSelector).forEach(fieldset => {
      const group = readGroup(fieldset);
      if (group && (!form || group.property.form === form)) normalize(group);
    });
  }

  window.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('input[type="checkbox"]')) return;
    normalize(readGroup(input.closest('fieldset')), input);
  }, true);

  window.addEventListener('click', event => {
    const button = event.target.closest?.('button[type="submit"], input[type="submit"], button[name="add"]');
    if (button?.form) sync(button.form);
  }, true);
  window.addEventListener('submit', event => sync(event.target), true);
  window.addEventListener('pageshow', () => sync());
  document.addEventListener('reset', () => setTimeout(() => sync(), 0));
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches?.('fieldset, input[type="checkbox"]') || node.querySelector?.('fieldset, input[type="checkbox"]'))
    ))) sync();
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();
